// @flow
import * as React from 'react';
import gql from 'graphql-tag';
import idx from 'idx';
import { graphql, compose } from 'react-apollo';

import ToastActions from 'actions/ToastActions';

import EDIT_SFTP_CREDS_MUTATION from './queries/EditSftpCredentialsMutation.gql';
import REVOKE_SFTP_CREDS_MUTATION from './queries/RevokeSftpCredentialsMutation.gql';

type Props = {
  children: Function,
  credentialsUuid: ?string,
  onCredentialDeletion: () => void,
  data: ReactApolloData<AdminAutoMessageSftpCredentialsByUuidQuery>,
  edit: (input: EditAutoMessageSftpCredentialsInput) => Promise<*>,
  revoke: (input: RevokeAutoMessageSftpCredentialsInput) => Promise<*>,
};

class AdminAutoMessageSftpCredentialsFormContainer extends React.Component<Props, void> {
  handleCredentialChange = (name: string) => {
    const { credentialsUuid } = this.props;
    this.props.edit({ name, credentialsUuid }).then(
      res => {
        const { error } = res.data.editAutoMessageSftpCredentials;
        if (error) {
          console.warn(error);
          console.error(
            'AdminNewAutoMessageSftpCredentials - editAutoMessageSftpCredentials failure'
          );
          ToastActions.showAPIError(error);
          return;
        }
        ToastActions.showSuccessToast('Name successfully changed');
      },
      err => {
        console.warn(err);
        console.error(
          'AdminNewAutoMessageSftpCredentials - editAutoMessageSftpCredentials failure'
        );
        ToastActions.showAPIError(err);
      }
    );
  };

  handleCredentialDeletion = () => {
    const { credentialsUuid } = this.props;
    this.props.revoke({ uuid: credentialsUuid }).then(
      res => {
        const { error } = res.data.revokeAutoMessageSftpCredentials;
        if (error) {
          console.warn(error);
          console.error(
            'AdminNewAutoMessageSftpCredentials - revokeAutoMessageSftpCredentials failure'
          );
          ToastActions.showAPIError(error);
          return;
        }
        ToastActions.showSuccessToast('Credentials successfully revoked');
        this.props.onCredentialDeletion();
      },
      err => {
        console.warn(err);
        console.error(
          'AdminNewAutoMessageSftpCredentials - revokeAutoMessageSftpCredentials failure'
        );
        ToastActions.showAPIError(err);
      }
    );
  };

  render() {
    const { data, children } = this.props;

    return children({
      loading: idx(data, _ => _.loading),
      sftpCredentials: idx(data, _ => _.autoMessaging.sftpCredentials[0]),
      onCredentialChange: this.handleCredentialChange,
      onCredentialDeletion: this.handleCredentialDeletion,
    });
  }
}

const withExistingCredentials = graphql(
  gql`
    query AdminAutoMessageSftpCredentialsByUuid($uuid: String!) {
      autoMessaging {
        sftpCredentials(uuids: [$uuid]) {
          uuid
          name
          messages {
            uuid
            messageName
          }
          credentials {
            username
            password
          }
        }
      }
    }
  `,
  {
    options: ({ credentialsUuid }) => ({
      variables: { uuid: credentialsUuid },
    }),
  }
);

const withEditMutation = graphql(EDIT_SFTP_CREDS_MUTATION, {
  props: ({ mutate }) => ({
    edit(input: EditAutoMessageSftpCredentialsInput) {
      return mutate({ variables: { input } });
    },
  }),
});
const withRevokeMutation = graphql(REVOKE_SFTP_CREDS_MUTATION, {
  props: ({ mutate }) => ({
    revoke(input: RevokeAutoMessageSftpCredentialsInput) {
      return mutate({ variables: { input } });
    },
  }),
});

export { AdminAutoMessageSftpCredentialsFormContainer };

export default compose(
  withExistingCredentials,
  withEditMutation,
  withRevokeMutation
)(AdminAutoMessageSftpCredentialsFormContainer);
